export const permissions = {
  dashboard: {
    required: ["BULK_ANALYTIC_REPORT"],
  },
  attribute: {
    required: ["CREATE_ATTRIBUTE"],
  },
  catalog: {
    required: ["CREATE_CATALOG"],
  },
  item: {
    oneOf: ["CREATE_ITEM"],
  },
  tenant: {
    required: ["CREATE_TENANT"],
  },
  role: {
    required: ["CREATE_ROLE"],
  },
  permission: {
    required: ["CREATE_PERMISSION"],
  },
  feature: {
    required: ["CREATE_FEATURE"],
  },
  inventory: {
    oneOf: ["LOAD_INVENTORY"],
  },
  approvalNotification: {
    oneOf: ["LIST_BULK_NOTIFICATION"],
  },
  bulkNotification: {
    oneOf: ["CREATE_BULK_NOTIFICATION"],
  },
  partner: {
    required: ["CREATE_PARTNER"],
  },
  subscription_pricing: {
    oneOf: ["SUBSCRIPTION_PRICING_CREATE"],
  },
  businessPlan: {
    required: ["CREATE_BUSINESS_PLAN"],
  },
  customer: {
    oneOf: ["CUSTOMER_EXPORT"],
  },
  sub_tenant: {
    required: ["CREATE_ADMIN"],
  },
  office_org: {
    oneOf: ["PARTNER_LIST"],
  },
  orders_management: {
    oneOf: ["ORDER_DETAIL_BY_ID"],
  },
  commission: {
    oneOf: ["COMISSIONRULETRANSACTION_LIST"],
  },
  subscriptionplan: {
    oneOf: ["CREATE_SUBSCRIPTION_PLAN"],
  },
  accessrule: {
    oneOf: ["SUBSCRIPTION_ACCESS_RULES_CREATE"],
  },
  deliverysetup: {
    oneOf: ["CREATE_CHARGE_CONFIG"],
  },
  taxcodeSetup: {
    oneOf: ["PRICING_TAXCODE_PUT"],
  },
  couponSetup: {
    oneOf: ["CREATE_PROMOTION"],
  },
  serviceRequestSetup: {
    oneOf: ["CREATE_SERVICE_REQUEST_CATEGORY"],
  },
  commissionSetup: {
    oneOf: ["COMISSIONRULEASSIGN_CREATE"],
  },
  FAQSetup: {
    oneOf: ["CREATE_FAQ"],
  },
  advertisement: {
    oneOf: ["ADVERTISEMENT_CREATE"],
  },
  concern: {
    oneOf: ["CREATE_CONCERNS"],
  },
  payment_history: {
    oneOf: ["PAYMENT_HISTORY"],
  },
  customer_management: {
    required: ["CUSTOMER_SEARCH"],
    
  },
  manage_own_customer: {
    oneOf: ["GET_PARTNER_CUSTOMER_DETAILS"],
  },
  service_ticket: {
    oneOf: ["LIST_TICKET"],
  },
  templateCreation: {
    oneOf: ["smsemail"],
  },
  Resources: {
    oneOf: ["CREATE_WALLET_RESOURCE_MASTER"],
  },
  approval: {
    oneOf: ["LIST_PARTNER_APPROVAL_REQUEST"],
  },
  bulkPromotion: {
    oneOf: ["LIST_CRITERIA"],
  },
  onboardCustomer: {
    oneOf: ["ONBOARD_CREATE_ORDER"],
  },
  unitManagement: {
    oneOf: ["CREATE_UNIT"],
  },
  //no permission in the api ,hence added static permission
  applyPromo: {
    oneOf: ["LIST_CRITERIA"],
  },
  faq: {
    oneOf: ["READ_FAQ"],
  },
  setup: {
    oneOf: ["CREATE_SETUP"],
  },
  suboffice_org: {
    oneOf: ["SUB_OFFICE_HIERARCHY"],
  },

  //permission not in use
  serviceRequest: {
    oneOf: ["LIST_SERVICE_REQUEST_CATEGORY"],
  },
  discount_coupons: {
    oneOf: ["DISCOUNT_COUPONS"],
  },
  offerImage: {
    oneOf: ["OFFER_IMAGE"],
  },
  promotion: {
    oneOf: ["MANAGE_PROMOTION"],
  },
  manage_team: {
    oneOf: ["MANAGE_TEAM"],
  },
};
